import React from "react";
import { useColors } from "../contexts/ColorContext";

function Hero() {
  const { getClasses } = useColors();

  return (
    <section id="inicio" className="bg-gray-100 py-20">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h2
              className={`text-4xl font-bold ${getClasses("secondary-text")} mb-6`}
            >
              Soluciones Profesionales para su Negocio
            </h2>
            <p className="text-lg text-gray-700 mb-8">
              En Jambops Solutions nos comprometemos a entregar servicios de la
              más alta calidad. Nuestro enfoque en la excelencia nos distingue
              en el mercado español, ofreciendo soluciones tanto eléctricas como
              digitales para satisfacer sus necesidades.
            </p>
            <p
              className={`text-xl ${getClasses("primary-text")} font-semibold mb-8`}
            >
              Contáctenos para su presupuesto gratuito
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <a
                href="#servicios"
                className={`${getClasses("primary")} ${getClasses("primary-hover")} text-white font-semibold py-3 px-6 rounded-lg transition duration-300 text-center`}
              >
                Nuestros Servicios
              </a>

              <div className="inline-flex rounded-lg overflow-hidden">
                <a
                  href="#contacto"
                  className={`bg-white hover:bg-gray-100 ${getClasses("primary-text")} font-semibold ${getClasses("primary-border")} border border-r-0 py-3 px-6 transition duration-300 rounded-l-lg text-center`}
                >
                  Contactar
                </a>
                <a
                  href="https://wa.me/34648715645?text=Hola!%20Me%20gustaria%20solicitar%20mas%20informacion%20sobre:%20%20"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-4 rounded-r-lg transition duration-300 flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="text-white"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <div
              className={`${getClasses("primary")} h-64 w-64 rounded-full relative overflow-hidden flex items-center justify-center shadow-xl`}
            >
              <img src="logo.jpeg" alt="Jambops Logo"></img>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
